import React, { FunctionComponent } from 'react';
import {
  AsyncState,
  InstitutionAdminSettingsState,
} from 'src/ReduxStorage/InstitutionAdminSettings/types';
import {
  PortalResourceGetPaginatedEnrolments,
  PortalResourceGetPaginatedPendingInvitations,
} from 'src/resource/PortalResource/types';
import { ActiveTeamMemberTable } from './ActiveTeamMemberTable/component';
import { PendingTeamMemberTable } from './PendingTeamMemberTable/component';
import {
  EmptyContentWrapper,
  Header,
  PendingTeamAlertMessage,
  AddTeamMember,
  GlobalStylingForModal,
} from './styles';
import baloonImage from './images/Undraw_Floating balloons.svg';

export interface ViewTeamMembersProps {
  paginatedInstitutionEnrolments: InstitutionAdminSettingsState['paginatedInstitutionEnrolments'];
  paginatedPendingInvitations: InstitutionAdminSettingsState['paginatedPendingInvitations'];
  currentInstitutionPath: string;

  getPaginatedEnrolments: (
    params: PortalResourceGetPaginatedEnrolments['args']
  ) => Promise<unknown>;
  getPaginatedPendingInvitations: (
    params: PortalResourceGetPaginatedPendingInvitations['args']
  ) => Promise<unknown>;
}

export const ViewTeamMembers: FunctionComponent<ViewTeamMembersProps> = ({
  paginatedInstitutionEnrolments,
  paginatedPendingInvitations,
  currentInstitutionPath,
  getPaginatedEnrolments,
  getPaginatedPendingInvitations,
}) => {
  const {
    enrolments,
    total,
    totalPages,
    asyncState,
  } = paginatedInstitutionEnrolments;

  const isActivePendingMembersEmpty = false;

  if (isActivePendingMembersEmpty) {
    return (
      <EmptyContentWrapper>
        <img alt="baloon" src={baloonImage} />
        <h1>Oops, it’s empty in here!</h1>
        <p>
          There are currently no team members in your institution. Get started
          by adding some team members.{' '}
        </p>
        <AddTeamMember type="button">Add team members</AddTeamMember>
      </EmptyContentWrapper>
    );
  }
  return (
    <div>
      {GlobalStylingForModal}
      <Header>Active team members</Header>
      <ActiveTeamMemberTable
        currentInstitutionPath={currentInstitutionPath}
        enrolments={enrolments}
        total={total}
        totalPages={totalPages}
        getPaginatedEnrolments={getPaginatedEnrolments}
        isLoadingData={asyncState === AsyncState.LOADING}
      />
      <hr />
      <Header>Pending team members</Header>
      <PendingTeamAlertMessage
        kind="info"
        message={
          <div>
            Team members who appear as pending have been invited to the
            institution, but:
            <ul>
              <li>Don’t have an account on OpenLearning; or</li>
              <li>Have an unverified account on OpenLearning.</li>
            </ul>
          </div>
        }
      />
      <PendingTeamMemberTable
        currentInstitutionPath={currentInstitutionPath}
        paginatedPendingInvitations={paginatedPendingInvitations}
        getPaginatedPendingInvitations={getPaginatedPendingInvitations}
      />
    </div>
  );
};
